'use client';

import { useMutation } from '@tanstack/react-query';

import { improveHubDescription } from '@website/services/hubs.service';

export function useImproveHubDescription() {
  return useMutation({ mutationFn: improveHubDescription });
}
